"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OfferInfo = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Root = (0, _mui.styled)(_mui.Typography)((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        display: 'flex',
        height: 45,
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        width: '100%',
        zIndex: 2,
        '&::before': {
            background: theme.palette.common.white,
            bottom: 0,
            content: "''",
            left: theme.spacing(-1),
            opacity: 0.95,
            position: 'absolute',
            right: theme.spacing(-1),
            top: 0,
            zIndex: -1
        }
    };
});
const OfferInfo = exports.OfferInfo = /*#__PURE__*/ (0, _react.forwardRef)((param, ref)=>{
    let { countSelected, requiredQuantity } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
        ref: ref,
        variant: "subtitle1",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
            id: "productsInOffer",
            values: {
                0: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                    component: "span",
                    fontWeight: "bold",
                    variant: "inherit",
                    children: countSelected
                }),
                1: requiredQuantity
            }
        })
    });
});
